<h4 *ngIf="headerText" class="account-dropdown -heading">
  {{ headerText }}
</h4>
<div class="account-dropdown -links">
  <ng-container *ngFor="let dropdownLink of dropdownTo">
    <a [routerLink]="'/' + dropdownLink.path">{{dropdownLink.title}}</a>
  </ng-container>
</div>